import React, { PureComponent } from 'react';

import ListingsDetails from './ListingsDetails';
import Listings from './Listings';
import ListingRow from './ListingRow';
import ListingHeader from './ListingHeader';
import { applyFilters, buildFilterList } from '../helper/Filter';
import { makeSortedDirs, sortListingsByCols } from '../util/listings';
import DetailActionContext from '../util/DetailActionContext';
import { computeGoBackState } from '../util/listingsScrollerGoBack';
import { resolveDefaultListing } from '../util/listingsScrollerDefaultList';

class ListingsScroller extends PureComponent {
	constructor(props) {
		super(props);
		
		// Will be set by Listings component via callback
		this.openWayfindingModalRef = null;

		this.state = {
			activeButton: '',
			activeRow: '',
			account_uuid: this.getAccountUUID(),
			css: props.CSSModules[props.condor_render_name],
			defaultList: this.getDefaultListing(this.props.default_list_shown),
			defaultListName: this.getDefaultListingName(this.props.default_list_shown),
			defaultKeyboard: this.props.default_keyboard,
			details: [],
			detailsCSS: props.CSSModules['ListingsDetails'],
			detailsHasRendered: false,
			detailsPage: false,
			detailsTouchAction: this.getDetailsTouchAction(this.props.default_list_shown),
			detailsTitle: '',
			detailsUUID: '',
			currentDetailAction: this.getDetailsTouchAction(this.props.default_list_shown),
			disabledButton: false,
			etlData: props.tmp_data_etl || {},
			history: [],
			rowCss: [],
			tierLevel: 0,
			tieredDetails: [],
			tieredHeaders: [],
			scrollButtons: this.props.scroll_buttons,
			scrollDistance: this.props.scroll_distance,
			messageLabels: this.props.messaging,
			filteredListings: [], // Filtered results
			lastSearchValue: '', // Track last search value
		};
	}

	componentDidMount() {
		this.setSystemGroupAndAccount();
		this.scheduleUpdateDefaultList();
	}

	scheduleUpdateDefaultList = () => {
		const fifteenMinutes = 15 * 60 * 1000;
		const tenSeconds = 10 * 1000;
		const now = Date.now();
		const currentWindow = now - (now % fifteenMinutes);
		const nextWindow = currentWindow + fifteenMinutes + tenSeconds;
		const timeUntilNextWindow = nextWindow - now;

		clearTimeout(this.nextTimeout);

		this.nextTimeout = setTimeout(() => {
			this.updateDefaultList();
		}, timeUntilNextWindow);
	}

	// Re-derive defaultList only when its content actually changes,
	// so child components can rely on cheap reference equality.
	updateDefaultList = () => {
		const newDefaultList = this.getDefaultListing(this.props.default_list_shown);
		if (JSON.stringify(newDefaultList?.listings) !== JSON.stringify(this.state.defaultList?.listings)) {
			this.setState({ defaultList: newDefaultList });
		}
		this.scheduleUpdateDefaultList();
	}

	setOpenWayfindingModalRef = (fn) => {
		this.openWayfindingModalRef = fn;
	}

	getOpenWayfindingModal = () => {
		// Try the callback ref first, then try component ref, then try props.openWayfindingModal
		const callbackMethod = this.openWayfindingModalRef;
		const refMethod = this.listingsRef?.openWayfindingModal;
		const propsMethod = this.props.openWayfindingModal;
		
		// Bind to the Listings component if using ref method
		let method = callbackMethod || refMethod || propsMethod;
		if (method && this.listingsRef && method === refMethod) {
			method = method.bind(this.listingsRef);
		}
		
		return method || null;
	}

	scrollListingsToTop = () => {
		const scroller = document.getElementById('listingsScroller');
		if (scroller) scroller.scrollTop = 0;
	}

	setCurrentDetailAction = (value) => {
		this.setState({ currentDetailAction: value });
	}

	componentDidUpdate(prevProps, prevState) {
		if ((this.props.navProps.timeoutStatus !== prevProps.navProps.timeoutStatus && !this.props.navProps.timeoutStatus) && this.props.navProps.animationPhase === this.props.navProps.animationStartPhase) {
			this.setState({
				detailsPage: false,
				detailsTitle: '',
				detailsUUID: '',
				details: [],
				history: [],
				detailsHasRendered: false,
				tierLevel: 0,
				tieredDetails: [],
				tieredHeaders: [],
				currentDetailAction: this.state.detailsTouchAction
			}, () => {
				this.scrollListingsToTop();
			});
		}
		if ((prevProps.tmp_data_etl !== this.props.tmp_data_etl) || (prevProps.last_update !== this.props.last_update)) {
			this.setState({
				defaultList: this.getDefaultListing(this.props.default_list_shown)
			});
		}
	}

	componentWillUnmount() {
		clearTimeout(this.closeDetailsTimeout1);
		clearTimeout(this.closeDetailsTimeout2);
		clearTimeout(this.nextTimeout);
	}

	setSystemGroupAndAccount() {
		const keys = Object.keys(window.flatData);
		let account, systemGroup;

		keys.find((key) => {
			if (key.startsWith('account.')) {
				account =  key;
			}
			if (key.startsWith('system_group.')) {
				systemGroup =  key;
			}
		});

		this.setState({
			account,
			systemGroup,
		});
	}

	getSystemOrPropertyOrAccountSetting = (mapSetting, checkbox = false) => {
		let settingValue = '';

		const account = window.flatData[this.state.account] || {};
		const systemGroup = window.flatData[this.state.systemGroup] || {};
		const activeSystem = window.flatData[`system.${this.props.system_uuid}`] || {};

		let accountSetting;
		if (mapSetting in account) {
			accountSetting = {
				value: account[mapSetting] ?? null
			};
		}

		let propertySetting;
		if (mapSetting in systemGroup) {
			propertySetting = {
				value: systemGroup[mapSetting] ?? null,
			};
		}

		let systemSetting;
		if (mapSetting in activeSystem) {
			systemSetting = {
				value: activeSystem[mapSetting] ?? null,
			};
		}

		if ((systemSetting?.value && !checkbox) || (checkbox && systemSetting?.value && systemSetting?.value !== false)) {
			settingValue = systemSetting.value;
		} else if ((propertySetting?.value && !checkbox) || (checkbox && propertySetting?.value && propertySetting?.value !== false)) {
			settingValue = propertySetting.value;
		} else if ((accountSetting?.value && !checkbox) || (checkbox && accountSetting?.value && accountSetting?.value !== false)) {
			settingValue = accountSetting.value;
		} else if (checkbox) {
			settingValue = false;
		} else {
			settingValue = '';
		}

		return settingValue;
	}


	getAccountUUID() {
		const flatData = window.flatData;

		const accountEntry = Object.keys(flatData).find(key => key.startsWith('account.'));
		if (accountEntry) {
			return accountEntry.split('.')[1];
		}

		return '';
	}

	getDefaultListingName = (listingConfigUUID) => {
		return window?.flatData?.[listingConfigUUID]?.display_name || '';
	}

	getDetailsTouchAction = (listingConfigUUID) => {
		return window?.flatData?.[listingConfigUUID]?.touch_action ?? 0;
	}

	// Fallback for an unresolvable default_list_shown. Listings reads
	// `defaultList.listings` unconditionally (buildListingsNav,
	// setCurrentListings), so the fallback must carry an empty listings array,
	// not a bare `{}`.
	static EMPTY_DEFAULT_LIST = { listings: [] };

	getDefaultListing = (listingConfigUUID) => {
		if (listingConfigUUID === '') {
			return ListingsScroller.EMPTY_DEFAULT_LIST;
		}
		console.log('Getting default listing for config UUID:', listingConfigUUID);

		const unfilteredEtlData = resolveDefaultListing({
			fd: window.flatData,
			etlData: this.props.tmp_data_etl,
			configToCollectionMap: this.props.configToCollectionMap,
			condorPropList: this.props.condor_prop_list,
			listingConfigUUID,
		});

		// DEV-12182: a default_list_shown that names a listing_config this
		// flatData does not contain (stale after a config swap, or a design
		// copied across accounts without its listing configurations) must not
		// crash the renderer — behave like an empty default list instead.
		if (!unfilteredEtlData) {
			console.warn('ListingsScroller: default_list_shown could not be resolved, rendering an empty list:', listingConfigUUID);
			return ListingsScroller.EMPTY_DEFAULT_LIST;
		}

		// Scheduling gate is resolved per listing inside buildFilterList (DEV-12036).
		let etlDataWithFilters = { ...unfilteredEtlData, listings: buildFilterList(unfilteredEtlData.listings) };
		let filteredEtlData = { ...etlDataWithFilters, listings: applyFilters(etlDataWithFilters.listings) };

		return filteredEtlData;
	}

	setDetailsPage = (detailsPage) => {
		this.setState({ detailsPage: detailsPage });
	}

	setDetailsUUID = (detailsUUID) => {
		this.setState({ detailsUUID: detailsUUID });
	}

	setDetailsAction = (detailsAction) => {
		this.setState({ detailsTouchAction: detailsAction });
	}

	setDetailsHasRendered = (detailsHasRendered) => {
		this.setState({ detailsHasRendered: detailsHasRendered });
	}

	setDetailsGrp = (detailsGrp) => {
		this.setState({ detailsGrp: detailsGrp });
	}

	setRowCSS = (rowCSS) => {
		this.setState({ rowCSS: rowCSS });
	}

	setHistory = (history) => {
		if (history.length === 0) {
			this.setState({ history: [] });
			return;
		}

		// React 19 fix: Use updater function and spread operator for immutable update
		// Don't mutate state directly - create new array
		this.setState(prevState => ({
			history: [...prevState.history, history]
		}));
	}

	setTieredHeadersAndDetails = (tieredHeaders, tieredDetails) => {
		this.setState({
			tieredHeaders,
			tieredDetails,
		});
	}

	setSearchValue = (setSearchValue) => {
		this.setState({ searchValue: setSearchValue });
	}

	setDetailsData = (listData, detailsUUID, detailsGrp, detailsTouchAction, openDetails = true) => {
		const listingDetails = Array.isArray(listData) ? listData[listData.length - 1] : null;

		if (detailsTouchAction) {
			this.setState({
				details: listData,
				detailsGrp: detailsGrp,
				detailsPage: openDetails,
				detailsUUID: detailsUUID,
				listingTier: listingDetails?.listingTier || 0,
				listingTierName: listingDetails?.listingTierName || null,
				detailsTouchAction: detailsTouchAction
			});
		} else {
			this.setState({
				details: listData,
				detailsGrp: detailsGrp,
				detailsPage: openDetails,
				detailsUUID: detailsUUID,
				listingTier: listingDetails?.listingTier || 0,
				listingTierName: listingDetails?.listingTierName || null
			});
		}
	}

	addToHistory = (parentIsTierPlusOne = false) => {
		this.setHistory({
			detailsTitle: this.state.detailsTitle,
			tieredDetails: this.state.tieredDetails,
			tieredHeaders: this.state.tieredHeaders,
			type: 'listing',
			returnMultiple: parentIsTierPlusOne,
			tierLevel: this.state.tierLevel,
			currentDetailAction: this.state.currentDetailAction
		});
	}

	setDetailsTitle = (detailsTitle) => {
		this.setState({ detailsTitle: detailsTitle });
	}

	closeDetailsPage = () => {
		// React 19 fix: Use updater function so that prevState reflects
		// any pending setHistory calls batched in the same update cycle.
		// Without this, React 18+ batching causes this.state.history.length
		// to read stale state when called alongside setHistory.
		this.setState(prevState => {
			const newState = { detailsPage: false };
			if (prevState.history.length === 0) {
				newState.detailsHasRendered = false;
				newState.detailsUUID = '';
			}
			return newState;
		});
	}

	handleDown = (buttonId) => {
		this.setState({ activeButton: buttonId });
	}

	handleUp = () => {
		this.setState({ activeButton: '' });
	}

	displayChildTier = (listingUUID, rowsArray = [], newTierListings, rowData, parentIsTierPlusOne = false, openWayfindingModal = null) => {
		// Use provided openWayfindingModal or fall back to Listings component's method
		let modalHandler = openWayfindingModal;
		if (!modalHandler) {
			modalHandler = this.getOpenWayfindingModal();
			// Bind the method to the Listings component instance if found
			if (modalHandler && this.listingsRef) {
				modalHandler = modalHandler.bind(this.listingsRef);
			}
		}
		let listingsArray = newTierListings || this.state.defaultList?.listings || [];
		let rowHeaders = [];
		let tieredHeaders = [];
		let detailsCSS = this.state.detailsCSS;
		let numberOfResults = 0;
		let touchAction = 0;
		let listInfo = listingsArray[0];

		if (!listInfo || !listInfo.colGroups || listInfo.colGroups.length === 0) {
			return null;
		}

		// For translation
		const { t } = this.props;

		listingsArray.forEach((listing, j) => {

			if (listing.m1Key === listingUUID) {
				let headerWidths = [];

				if (listing.listings.length === 0) {
					return;
				}
				touchAction = listing.listings[0]?.tierConfig?.touchAction ?? 0;
				listing.listings[0].colGroups.forEach((colGroup) => {
					headerWidths.push(colGroup.width);
				});

				let sortedCols = [...listing.listings[0].colGroups].filter((c) => {
					if (c.sort > 0) {
						return true;
					}

					return false;
				});

				sortedCols.sort((i, j) => {
					if (i.sort > j.sort) {
						return 1;
					}

					return -1;
				});

				listing.listings = listing.listings.map((listing) => {
					listing.sortedVals = [listing.rank || 0];

					for (let col of sortedCols) {
						listing.sortedVals.push(listing.vals[col.order - 1]);
					}

					return listing;
				});

				const sortedDirs = makeSortedDirs(sortedCols);

				listing.listings.sort((a, b) => {
					return sortListingsByCols(a, b, sortedDirs);
				});

				listing.listings.forEach((row, i) => {
					let textAlign = [];

					if (numberOfResults < 500) {
						numberOfResults++;

						let currentHeaderWidths = row.colGroups.map((colGroup) => {
							return colGroup.width;
						});

						let listingsWithType = [];
						row.vals.forEach((listingData, i) => {
							listingsWithType.push({
								value: listingData,
								type: listing.listings[0].types[i],
								displayName: listing.listings[0].displayNames[i],
								column_uuid: listing.listings[0].colGroups[i].m1Key
							});
						});
						// add tierConfig to listing detail
						listingsWithType.push(row.tierConfig);

						let headersArray = [];
						let headerAsLabelArray = [];
						row.colGroups.forEach((col) => {
							if (col.headerAsLabel) {
								headersArray.push(col.name);
								headerAsLabelArray.push(true);
							} else {
								headersArray.push('');
								headerAsLabelArray.push(false);
							}
						});

						row.colGroups.forEach((column) => {
							switch (column.textAlign) {
								case 0:
									textAlign.push('left');
									break;
								case 1:
									textAlign.push('center');
									break;
								case 2:
									textAlign.push('right');
									break;
								default:
									textAlign.push('center');
									break;
							}
						});

						if (row.colGroups.length !== 0) {
							// Don't show tier+1 button (touchAction 10) if this row has no child listings
							const effectiveTouchAction = (row.tierConfig.touchAction === 10 && (!row.listings || row.listings.length === 0))
								? 0
								: row.tierConfig.touchAction;

							rowsArray.push(
								<ListingRow
									{...this.props}
									activeRow={this.state.activeRow}
									addToHistory={this.addToHistory}
									boxActiveLayout={row.tierConfig.boxActiveLayout + 1}
									boxColumnsPerRow={row.tierConfig.boxColumnsPerRow + 1}
									boxStyleDisplay={row.tierConfig.boxStyleDisplay}
									css={currentHeaderWidths}
									currentDetailAction={effectiveTouchAction}
									data={listingsWithType}
									detailsGrp={row.detailsGrp}
									detailsTitle={this.state.details[0]}
									displayChildTier={this.displayChildTier}
									headerAsLabel={headerAsLabelArray}
									headerData={headersArray}
									key={`details_row_${i}`}
									messageLabels={this.state.messageLabels}
									num={i}
									openWayfindingModal={modalHandler}
									parent='ListingsScroller'
									rowUUID={row.m1Key}
									setDetailsData={this.setDetailsData}
									setDetailsTitle={this.setDetailsTitle}
									textAlign={textAlign}
								/>
							);
						}
					}

					if (tieredHeaders.length < 1) {
						if (listing.listings.length > 0) {
							listing.listings[0].colGroups.forEach((colGroup) => {
								rowHeaders.push(colGroup.name);
							});
						}

						if (!row.tierConfig.boxStyleDisplay) {
							tieredHeaders.push(
								<div className={detailsCSS.header} key={`tieredHeader_${j}`}>
									<ListingHeader
										{...this.props}
										data-key={`tieredHeader`}
										data={rowHeaders}
										css={headerWidths}
										textAlign={textAlign}
										currentDetailAction={row.tierConfig.touchAction}
									/>
								</div>
							);
						}
					}


					if (numberOfResults >= 500) {
						tieredHeaders.unshift(<p className={detailsCSS.overLimit}>{t('listingsTooManyResultsError')}</p>);
					}
				});

				const uniqueRows = [...new Map(rowsArray.map((m) => {
					return [m.props.rowUUID, m];
				})).values()];

			this.addToHistory(parentIsTierPlusOne);

			this.setState(prevState => ({
				tieredDetails: uniqueRows,
				tieredHeaders: tieredHeaders,
				touchAction: touchAction,
				tierLevel: prevState.tierLevel + 1,
				currentDetailAction: touchAction
			}), () => {
				this.scrollListingsToTop();
			});
			// the || operator is here to avoid crashing Condor when closing a details page
			this.setDetailsTitle(rowData || '');
			setTimeout(() => {
				this.setState({
					pathStyle: 'animatePath'
				});
			}, 1500);
			} else if (listing.listings && listing.listings.length > 0) {
				this.displayChildTier(listingUUID, rowsArray, listing.listings, rowData?.value, parentIsTierPlusOne, modalHandler);
			}
		});
	}

	backButton = () => {
		this.goBack();
		this.props.navEvents('idleTimer', '||| ListingsScroller.js > buildBackBtn');
	}

	buildBackBtn = () => {
		let { css, detailsPage, history, disabledButton, activeButton } = this.state;
		let adaClass = this.props.navProps.adaActive ? css.adaActive : '';
		let disabledButtonClass = disabledButton ? css.disabledButton : '';
		let activeButtonClass = activeButton === 'backButton' ? `${css.activeButton} activeButton` : '';
		let disabledButtonStyle = disabledButton ? { pointerEvents: 'none', opacity: '0.5' } : {};

		if (detailsPage || history?.length > 0) {
			return (
				<div
					className={`${css.backBtn} listingsScrollerBackBtn ${adaClass} ${disabledButtonClass} ${activeButtonClass} ${disabledButton ? 'disabledBackButton' : ''}`}
					style={disabledButtonStyle}
					onMouseDown={(e) => {
						e.stopPropagation();
						this.handleDown('backButton');
						this.props.navEvents('btnDebouncer', this.backButton);
					}}
					onMouseUp={this.handleUp}
					onMouseLeave={this.handleUp}
					onTouchStart={(e) => {
						e.stopPropagation();
						this.handleDown('backButton');
						this.props.navEvents('btnDebouncer', this.backButton);
					}}
					onTouchEnd={this.handleUp}
					onPointerDown={(e) => {
						e.stopPropagation();
						this.handleDown('backButton');
						this.props.navEvents('btnDebouncer', this.backButton);
					}}
					onPointerUp={this.handleUp}
					onPointerLeave={this.handleUp}
				></div>
			);
		}
	}

	temporarilyDisableButton = () => {
		this.setState({ disabledButton: true });
		setTimeout(() => {
			this.setState({ disabledButton: false });
		}, 800);
	}

	disableBackButton = () => {
		this.setState({ disabledButton: true });
	}

	handleBoxData = (boxStyleDisplay, boxColumnsPerRow, boxActiveLayout) => {
		this.setState({
			boxStyleDisplay: boxStyleDisplay,
			boxColumnsPerRow: boxColumnsPerRow,
			boxActiveLayout: boxActiveLayout
		});
	}

	handleHeaderAsLabel = (headerAsLabel) => {
		this.setState({
			headerAsLabel: headerAsLabel
		});
	}

	// State-transition logic lives in util/listingsScrollerGoBack so it can be unit-tested.
	goBack = () => {
		const newState = computeGoBackState(this.state);

		if (this.state.history.length === 0) {
			this.setState(newState, () => {
				this.scrollListingsToTop();
			});
			return;
		}

		const lastHistoryElement = this.state.history[this.state.history.length - 1];
		this.setState(newState, () => {
			if (lastHistoryElement.type === 'listing') {
				// Delay detailsHasRendered update
				requestAnimationFrame(() => {
					this.setState({ detailsHasRendered: false });
				});
			}
			this.scrollListingsToTop();
		});
	};

	// Optimize details mounting/unmounting
	handleDetailsUnmount = () => {
		requestAnimationFrame(() => {
			this.setState({
				disabledButton: false,
				detailsHasRendered: false
			});
		});
	};

	render() {
		let css = this.state.css;
		let scrollBtnStyle = '';
		if (this.state.scrollButtons === 1 || this.state.scrollButtons === 2) {
			scrollBtnStyle = 'useScrollButtons';
		}

		if (this.props.default_list_shown === '') {
			return <div />;
		}

		const labelSeperator = {
			0: ' ',
			1: ': ',
			2:  ' - ',
		}

		const commonProps = {
			...this.props,
			account:			          this.state.account,
			activeRow:   	              this.state.activeRow,
			closeDetailsPage:             this.closeDetailsPage,
			defaultList:                  this.state.defaultList,
			details:                      this.state.details,
			detailsPage:                  this.state.detailsPage,
			detailsTouchAction:           this.state.detailsTouchAction,
			displayChildTier:             this.displayChildTier,
			openWayfindingModal:          this.getOpenWayfindingModal(),
			etlData:                      this.props.tmp_data_etl,
			handleRowDown: 		          this.handleRowDown,
			handleRowUp: 		          this.handleRowUp,
			labelSeperator:				  labelSeperator,
			scrollButtons:                this.state.scrollButtons,
			scrollDistance:               this.state.scrollDistance,
			setHistory:                   this.setHistory,
			setDetailsData:               this.setDetailsData,
			setDetailsTitle:              this.setDetailsTitle,
			setTieredHeadersAndDetails:   this.setTieredHeadersAndDetails,
			showOnPhase:                  this.props.showOnPhase,
			systemGroup:                  this.state.systemGroup,
			tierLevel:                    this.state.tierLevel,
			tieredDetails:                this.state.tieredDetails,
			tieredHeaders:                this.state.tieredHeaders,

			// wayfindingData
			locationMarkerUse:   this.getSystemOrPropertyOrAccountSetting('wf_location_marker_use', true),
			locationMarkerColor: this.getSystemOrPropertyOrAccountSetting('wf_location_marker_color'),
			locationMarkerSize:  this.getSystemOrPropertyOrAccountSetting('wf_location_marker_size'),
			mapDelayIn:          this.getSystemOrPropertyOrAccountSetting('wf_map_delay_in'),
			mapDelayOut:         this.getSystemOrPropertyOrAccountSetting('wf_map_delay_out'),
			pathColor:           this.getSystemOrPropertyOrAccountSetting('wf_path_color'),
			pathEndmarker:       this.getSystemOrPropertyOrAccountSetting('wf_path_endmarker'),
			pathEndmarkerSize:   this.getSystemOrPropertyOrAccountSetting('wf_path_endmarker_size'),
			pathWidth:           this.getSystemOrPropertyOrAccountSetting('wf_path_width'),
			pathSpeed:           this.getSystemOrPropertyOrAccountSetting('wf_path_speed'),
			pathType:            this.getSystemOrPropertyOrAccountSetting('wf_path_type'),
			animIconColorBg:     this.getSystemOrPropertyOrAccountSetting('wf_anim_icon_color_bg'),
			animIconColorFill:   this.getSystemOrPropertyOrAccountSetting('wf_anim_icon_color_fill'),
			animIconType:        this.getSystemOrPropertyOrAccountSetting('wf_anim_icon_type'),
			showMapButtons:      this.getSystemOrPropertyOrAccountSetting('wf_show_map_buttons'),
		}

		return (
			<DetailActionContext.Provider value={{ currentDetailAction: this.state.currentDetailAction, setCurrentDetailAction: this.setCurrentDetailAction }}>
				<div className={`${css.contentContainer} listingsScrollerContentContainer ${scrollBtnStyle}`}>
					{this.buildBackBtn()}

					<Listings
						{...commonProps}
						addToHistory={this.addToHistory}
						defaultListName={this.state.defaultListName}
						detailsTitle={this.state.detailsTitle?.value ? this.state.detailsTitle.value : this.state.detailsTitle}
						defaultKeyboard={this.state.defaultKeyboard}
						handleBoxData={this.handleBoxData}
						handleHeaderAsLabel={this.handleHeaderAsLabel}
						messageLabels={this.state.messageLabels}
						setDetailsPage={this.setDetailsPage}
						setRowCSS={this.setRowCSS}
						setSearchValue={this.setSearchValue}
						setOpenWayfindingModalRef={this.setOpenWayfindingModalRef}
						ref={(ref) => {
							this.listingsRef = ref;
						}}
					/>

					{
						(this.state.detailsPage || this.state.detailsHasRendered) &&
						<ListingsDetails
							{...commonProps}
							boxActiveLayout={this.state.boxActiveLayout}
							boxColumnsPerRow={this.state.boxColumnsPerRow}
							boxStyleDisplay={this.state.boxStyleDisplay}
							detailsGrp={this.state.detailsGrp}
							detailsTitle={this.state.detailsTitle}
							detailsUUID={this.state.detailsUUID}
							disableBackButton={this.disableBackButton}
							goBack={this.goBack}
							handleDetailsUnmount={this.handleDetailsUnmount}
							headerAsLabel={this.state.headerAsLabel}
							listingTier={this.state.listingTier}
							listingTierName={this.state.listingTierName}
							messageLabels={this.state.messageLabels}
							searchValue={this.state.searchValue}
							setDetailsAction={this.setDetailsAction}
							setDetailsGrp={this.setDetailsGrp}
							setDetailsHasRendered={this.setDetailsHasRendered}
							setDetailsUUID={this.setDetailsUUID}
							showDetailsPage={this.state.detailsPage}
							temporarilyDisableButton={this.temporarilyDisableButton}
						/>
					}
				</div>
			</DetailActionContext.Provider>
		);
	}
}

export default ListingsScroller;
